import { render, staticRenderFns } from "./mchSalesList.vue?vue&type=template&id=12d2f3cd&scoped=true&"
import script from "./mchSalesList.vue?vue&type=script&lang=js&"
export * from "./mchSalesList.vue?vue&type=script&lang=js&"
import style0 from "./mchSalesList.vue?vue&type=style&index=0&id=12d2f3cd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d2f3cd",
  null
  
)

export default component.exports